/*
 * @Descripttion: 滑动组件
 * @Author: yang chenglin
 * @LastEditors: yang chenglin
 */
import React, { useState } from 'react';
import { DatePicker, NumberPicker, Range, Select } from '@alifd/next';
import moment from 'moment';
import styles from './index.module.scss';

const dayType = [
  {
    label: '区间',
    key: 'RANGE',
  },
  {
    label: '晚于',
    key: 'RANGEGT',
  },
  {
    label: '早于',
    key: 'RANGELT',
  },
  {
    label: '相对区间',
    key: 'RELRANGE',
  },
];

/**
 * opType 在dayType数组范围内
 * @param changeData-把组件的值提交到父组件，改变父组件的值
 * @param tagItem-整个标签的信息
 * tagItem.value[0].realValue: 1.三年 2.三个月 3.15天
 */
const TagSlider = ({
  tagItem = {}, changeData = (data) => {
  },
}) => {
  const [type, setType] = useState(tagItem.opType ? tagItem.opType : 'RANGE'); // 枚举类型见dayType
  const [data, setData] = useState(tagItem.opValue?.extra_map[0]?.slider ?? 0); // 区间的值更改前或后面的值适合用数组形式改变，所以自己内部维护一个数组

  const changeRel = (v) => {
    setData(v);
    changeData({
      opValue: {
        label_id: tagItem.id,
        extra_map: [
          {
            slider: v
          }
        ]

      },
      opType: type
    });
  };
  return (
    <div className={`${styles['tag-Slider']} tag-width`}>
      <div className={styles['flex-center']}>
        {/* 由于最后传给后端，是需要把值[1,3]传成 [-3, -1],所以在html结构取值处直接反向显示 */}
        <Range
          className="tag-range-slide"
          min={0}
          max={730}
          value={data}
          onChange={(val) => changeRel(val)}
        />
        {/* 这个‘最近’‘天’其实不应该写死，如果新加了别的标签，不可能通用 */}
        最近<NumberPicker
          min={0}
          max={730}
          value={data}
          onChange={(val) => changeRel(val)}
        />天
      </div>
      {
        !data && <div style={{ color: "#f33", marginTop: "5px" }}
          className={`iconfont icon-icon4-30 ${styles['tag-error-select']}`}
        >请选择{tagItem.labelDescription}
        </div>
      }
    </div>
  );
};
export default TagSlider;
